module.exports = __webpack_public_path__ + "static/img/icon slt video.ecc9f614.svg";